import { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getDocumentName } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { SectionTemplatePage_OneSectionTemplate_QueryDocument } from './useFindOneSectionTemplateQuery.hook';

export const useQueryInvalidation = (sectionTemplateId: Id) => {
  const queryClient = useQueryClient();

  const queryKeyToInvalidate = useMemo(
    () => [
      getDocumentName(SectionTemplatePage_OneSectionTemplate_QueryDocument),
      { id: sectionTemplateId },
    ],
    [sectionTemplateId],
  );

  const invalidateQueries = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: queryKeyToInvalidate });
  }, [queryClient, queryKeyToInvalidate]);

  return {
    invalidateQueries,
    queryKeyToInvalidate,
  };
};
